<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-dialog-docs-preview></ui-dialog-docs-preview></p>
<h1 id="description">Description</h1>
<p>Generic dialog that could contain any html. Easiest way to use this is just to inline this in your html. To create a new custom dialog component. Have a look in how alert-dialog and confirm-dialogs is built.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    (<span class="hljs-attr">click</span>)=<span class="hljs-string">"dialog.open()"</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Open dialog"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-dialog</span>
    #<span class="hljs-attr">dialog</span>=<span class="hljs-string">"ui-dialog"</span>
    [<span class="hljs-attr">config</span>]=<span class="hljs-string">"{{ '{' }} headerText: 'Dialog' {{ '}' }}"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ng-template</span> <span class="hljs-attr">ui-dialog-template</span>&gt;</span>
        Fill this with any HTML. Use ui-dialog-buttons to position you buttons.
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-dialog-buttons</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span> <span class="hljs-attr">text</span>=<span class="hljs-string">"I get it"</span> (<span class="hljs-attr">click</span>)=<span class="hljs-string">"dialog.close()"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-dialog-buttons</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ng-template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-dialog</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">config</td>
<td align="left">The options available</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
